import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://szyaibndfsdmmcmvwozj.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6eWFpYm5kZnNkbW1jbXZ3b3pqIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY4MjY3NDE2NywiZXhwIjoxOTk4MjUwMTY3fQ.9UY4EJ9cFnHrBEjrS3GXbI4ZF5AIRiSiCBYSkjkRWDU'
export const supabase = createClient(supabaseUrl, supabaseKey);